(function (window, $) {
  // copy link to clipboard
  $('.js-tournament-copy-link').on('click', function (e) {
    e.preventDefault();
    const url = $(this).data('url');
    if (SC.utils.copyTextToClipboard(url)) {
      confirmation(null, 'Link copied to clipboard.');
    } else {
      confirmation(null, 'Failed to copy link to clipboard.');
    }
  });

  // instagram share - copy link and open instagram
  $('.js-share-instagram').on('click', function (e) {
    e.preventDefault();
    const $link = $(this);
    const url = $link.data('url');
    if (SC.utils.copyTextToClipboard(url)) {
      confirmation(null, 'Link copied to clipboard. Open Instagram and share it with your friends.');
      SC.utils.popupCenter($link.attr('href'), 'Instagram', 500, 500);
    } else {
      confirmation(null, 'Failed to copy link to clipboard.');
    }
  });
})(window, jQuery);
